import { Env } from '@loca/mfe-vue3'

const allConfigs = require('../../config')

const curAppConfigs = allConfigs[Env.getAppType()]
// todo Thor联调暂时更改
const temEnv = window.parent.location.hostname.includes('peadmin-uat') ? 'test' : Env.getEnv()

// 获取当前版本对应的当前环境配置
const curEnvConfig = curAppConfigs[temEnv]

// 获取当前环境对应的环境配置
export default curEnvConfig
